// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadRecordingsByWorkAction } from '../../actions/recording';

export type State = {
  +[key: string]: {|
    +entities: Array<number>,
    +loaded: boolean,
    +loading: boolean,
    +loadedCursors: { +[key: string]: boolean },
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function recordingsByWork(
  state: State = initialState,
  action: LoadRecordingsByWorkAction
): State {
  if (action.type === 'FETCH_RECORDINGS_BY_WORK' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
